angular.module('impactx.productcoding').controller('ProductCodingEditDialogCtrl', ['$scope', '$mdDialog', 'TranslationService',
    'themeFactory', 'dataGen', 'ToastService',
    ProductCodingEditDialogCtrl]);

function ProductCodingEditDialogCtrl($scope, $mdDialog, TranslationService, themeFactory, dataGen, ToastService)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.deleteLabel = TranslationService.get("delete");
    $scope.theme = themeFactory.getTheme();

    var self = this;

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.save = function() {
        dataGen.postAsForm($scope, {data: $scope.data}, "/productcodinghierarchy/edit/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $mdDialog.hide();
        });
    };
    self.delete = function() {
        dataGen.postAsForm($scope, {data: $scope.data}, "/productcodinghierarchy/edit/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            $mdDialog.hide();
        });
    };

    var entriesToSend = JSON.parse(JSON.stringify(self.entries));
    for (var i = 0; i < entriesToSend.length; i++) {
        entriesToSend[i].entries = undefined;
        entriesToSend[i].coding = undefined;
    }
    dataGen.postAsForm($scope, {selectedNodes: entriesToSend, comId: self.comId}, "/productcodinghierarchy/edit/view");
}